// extracted by mini-css-extract-plugin
export default {"giftPointBody":"CustomerGiftTerms_giftPointBody__4SpFq","okBtn":"CustomerGiftTerms_okBtn__iiMgv","cashNotes":"CustomerGiftTerms_cashNotes__rn2da"};